<template>
  <footer id="kt_app_footer" class="py-4">
    <div class="app-container container-fluid d-flex flex-column flex-md-row flex-center flex-md-stack py-3 justify-content-center">
      <div class="w-md-65 mx-auto px-4">
        <div class="footer-logos">
            <a href="https://pixelroads.com.br/" target="_blank">
              <img src="/images/layout/logo-pixel-principal.png" alt="Pixel Roads" class="logo" height="35" />
            </a>
            <a href="http://adsplay.com.br" target="_blank" rel="noopener noreferrer">
              <img src="/images/v2/layout/LOGO-ADSPLAY-PRINCIPAL.png" alt="Pixel Roads" class="logo" height="35" />
            </a>
        </div>
        <hr class="footer-divider">
        <div class="footer-links fw-700">
          <a href="https://pixelroads.com.br/termos-e-privacidade/" target="_blank" class="link-color9">{{ $t('privacy_policy') }}</a>
          <a href="https://pixelroads.com.br/termos-e-privacidade/" target="_blank" class="link-color9">{{ $t('cookie_policy') }}</a>
          <div class="d-flex align-items-center gap-1">
            <span>{{ $t('follow_us') }}:</span>
            <a href="https://www.instagram.com/pixelroadsbr/" target="_blank">
              <img src="/images/v2/layout/icon-insta.svg" alt="icon instagram" class="icon">
            </a>
            <a href="https://www.linkedin.com/company/pixelroads/" target="_blank">
              <img src="/images/v2/layout/icon-linkedin.svg" alt="icon linkedin" class="icon">
            </a>
            <a href="https://www.youtube.com/@pixelroads" target="_blank">
              <img src="/images/v2/layout/icon-yt.svg" alt="icon youtube" class="icon">
            </a>
            <a href="https://www.tiktok.com/@pixelroadsbr" target="_blank">
              <img src="/images/v2/layout/icon-tiktok.svg" alt="icon tiktok" class="icon">
            </a>
            <a href="https://open.spotify.com/show/1bk23Ltc9krWFL648RZMvh?si=cdfe97b67b7a42fb" target="_blank">
              <img src="/images/v2/layout/icon-spotify.svg" alt="icon spotify" class="icon">
            </a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'TheFooter',
  computed: {
    currentYear () {
      return new Date().getFullYear()
    }
  }
}
</script>

<style lang="scss" scoped>
.app-footer {
  background-color: #F8F9FA;
  // height: 10%;
}

.footer-logos {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-bottom: 14px;
}

.footer-divider {
  border: none;
  border-top: 1px solid #2D2D2D !important;
  margin: 0 auto 10px;
  opacity: 1;
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 24px 40px;
}

  .icon {
    width: 40px;
    height: 40px;
    // background: #f2f2ec;
  }

</style>
